import { render, staticRenderFns } from "./JointsConfiguratorTemplate.vue?vue&type=template&id=30444b62&scoped=true"
import script from "./JointsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsConfiguratorTemplate.vue?vue&type=style&index=0&id=30444b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30444b62",
  null
  
)

export default component.exports